import { useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger); // ← Wajib ditambahkan

export default function Services() {
    useEffect(() => {
        gsap.utils.toArray(".service-card").forEach((card) => {
            gsap.from(card, {
                scrollTrigger: {
                    trigger: card,
                    toggleActions: "play none none none",
                },
                opacity: 0,
                x: -100,
                duration: 1,
                ease: "power2.out",
            });
        });
    }, []);

    return (
        <section id="services" className="services-section section">
            <div className="container">
                <h2 className="section-title">Our Services</h2>
                <p className="section-description">
                    Solusi Terintegrasi untuk Kebutuhan IT, Audio Visual, & Automation. Kami menawarkan berbagai layanan untuk memenuhi kebutuhan teknologi, di antaranya:
                </p>
                <div className="row">
                    {/* Layanan 1 */}
                    <div className="col-md-4 service-card">
                        <h3>IT, Audio Visual, & Automation</h3>
                        <p>
                            Menyediakan solusi untuk ruang konferensi, ruang rapat, ruang kelas, auditorium, ballroom, command center, dan lain-lain.
                        </p>
                    </div>

                    {/* Layanan 2 */}
                    <div className="col-md-4 service-card">
                        <h3>Desain 3 Dimensi Interior</h3>
                        <p>
                            Menyediakan visualisasi ruang yang memungkinkan klien melihat implementasi perangkat secara nyata dalam desain.
                        </p>
                    </div>

                    {/* Layanan 3 */}
                    <div className="col-md-4 service-card">
                        <h3>Integrasi Sistem IT, Audio Visual & Automation</h3>
                        <p>
                            Kami menghubungkan berbagai perangkat untuk menciptakan sistem yang berkolaborasi dan mudah digunakan.
                        </p>
                    </div>

                    {/* Layanan 4 */}
                    <div className="col-md-12 service-card">
                        <h3>Dukungan dan Pemeliharaan</h3>
                        <p>
                            Memberikan layanan purna jual berupa dukungan teknis dan pemeliharaan sistem untuk memastikan perangkat selalu berfungsi optimal.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}